const containerCollection = document.querySelector('.js-collection')

/**
 * Convert form data (FormData) into a search string
 *
 * The search string doesn't include the starting `?` symbol.
 */
const convertFormDataToSearch = (dataRaw) => {
  const data = [...dataRaw.entries()]

  return data
    .flatMap(
      // Bun.js/Node.js global types simplify the FormData entry to a string tuple
      // So we have to treat the value as unknown and narrow it down manually
      ([key, value]) => {
        if (typeof value !== 'string') {
          return []
        }

        return [
          `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`
        ]
      }
    )
    .join('&')
}



if(containerCollection){
  const triggers = containerCollection.querySelectorAll('.js-filter-accordion-trigger')
  const activatedFilter = containerCollection.querySelector('.js-activated-filter')
  const mql = window.matchMedia('(max-width: 1024px)')
  const checkboxes = containerCollection.querySelectorAll('.js-filter-checkbox')
  const submitButton = containerCollection.querySelector('.js-sumbit-filters')

  const queryTerms = containerCollection.querySelector('.js-search-terms')
  const searchType = containerCollection.querySelector('.js-search-types')

  const applySorting = containerCollection.querySelector('.js-apply-sorting')

  checkboxes?.forEach((checkbox) => {
    checkbox.addEventListener('click', () => {
      const checkedCheckboxes = containerCollection.querySelectorAll('.js-filter-checkbox:checked')
      if (checkedCheckboxes.length > 0) {
        submitButton?.removeAttribute('disabled')
      } else {
        submitButton?.setAttribute('disabled', '')
      }
    })
  })
  containerCollection.querySelectorAll('.js-filter-price').forEach((input) => { input.addEventListener('input', () => { submitButton?.removeAttribute('disabled') }) })

  const applySortAndFiltersDesktop = () => {
    const sortOrderItem = containerCollection.querySelector('#js-collection-sorting')

    
    const sortOrder = sortOrderItem instanceof HTMLSelectElement ? sortOrderItem.value : new URL(window.location.href).searchParams.get('sort_by')
    const form = containerCollection.querySelector('#js-filters-form')

    if (form instanceof HTMLFormElement) {
      const dataRaw = new FormData(form)

      const formSerialize = convertFormDataToSearch(dataRaw)

      const uri = new URL(window.location.href)
      uri.search = '?' + formSerialize
      if (sortOrder) uri.searchParams.set('sort_by', sortOrder)

      if (queryTerms !== null && queryTerms instanceof HTMLInputElement) {
        const q = queryTerms.value
        uri.searchParams.set('q', q)
      }

      if (searchType !== null && searchType instanceof HTMLInputElement) {
        const type = searchType.value
        uri.searchParams.set('type', type)
      }

      window.location.href = uri.toString()
    }
  }

  const applySortMobile = () => {
    const mobileList = containerCollection.querySelector('.js-sort-mobile-list')
    const checkedOption = mobileList.querySelector('input[name="radio"]:checked')
    const sortOrder = checkedOption?.getAttribute('value')

    
    const form = containerCollection.querySelector('#js-filters-form')

    if (form instanceof HTMLFormElement) {
      const dataRaw = new FormData(form)

      const formSerialize = convertFormDataToSearch(dataRaw)

      const uri = new URL(window.location.href)
      uri.search = '?' + formSerialize
      if (sortOrder) uri.searchParams.set('sort_by', sortOrder)

      if (queryTerms !== null && queryTerms instanceof HTMLInputElement) {
        const q = queryTerms.value
        uri.searchParams.set('q', q)
      }

      if (searchType !== null && searchType instanceof HTMLInputElement) {
        const type = searchType.value
        uri.searchParams.set('type', type)
      }

      window.location.href = uri.toString()
    }
  }

  applySorting.addEventListener('click', () => {
    applySortMobile()
  })

  const sortingSelector = containerCollection.querySelector('#js-collection-sorting')

  sortingSelector?.addEventListener('change', () => {
    applySortAndFiltersDesktop()
  })

  const filters = containerCollection.querySelector('#js-filters-form')

  filters?.addEventListener('submit', (evt) => {
    evt.preventDefault()
    if (mql.matches) {
      applySortMobile()
    } else {
      applySortAndFiltersDesktop()
    }
  })

  triggers?.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const bodyId = trigger.getAttribute('aria-controls')
      const body = document.getElementById(bodyId || '')

      if (!body) {
        return
      }

      const isOpen = body.classList.contains('open')

      if (isOpen) {
        trigger.classList.remove('open')
        const sectionHeight = body.scrollHeight
        body.style.height = sectionHeight + 'px'
        void body.offsetHeight // force reflow
        body.style.height = '0px'
        body.classList.remove('open')
        trigger.setAttribute('aria-expanded', 'false')
      } else {
        trigger.classList.add('open')
        const sectionHeight = body.scrollHeight
        body.style.height = '0px'
        body.classList.add('open')
        trigger.setAttribute('aria-expanded', 'true')
        void body.offsetHeight // force reflow
        body.style.height = sectionHeight + 'px'
      }

      body.addEventListener(
        'transitionend',
        () => {
          if (body.classList.contains('open')) {
            body.style.height = 'auto'
          } else {
            body.style.removeProperty('height')
          }
        },
        { once: true }
      )
    })
  })

  activatedFilter?.forEach((filter) => {
    filter.addEventListener('click', () => {
      const urlToRemove = filter.getAttribute('data-url-to-remove')
      if (urlToRemove) {
        window.location.href = urlToRemove
      }
    })
  })
}